import { createReducer } from '@reduxjs/toolkit';

import { searchActions } from '../elevio.actions/search';

/** Search state for a given conversation */
type SearchState = {
  /** Term used to fetch articles */
  searchTerm: string;
};

/** Store of suggestion states on a per-conversation basis */
type SearchStore = {
  [conversationId: number]: SearchState;
};

export type ElevioSearchState = {
  /** Search input value - a non-debounced value */
  searchInputValue: string;
  /**
   * Suggestion state for each conversation - stores article being viewed on a
   * per-conversation basis
   */
  searchStore: SearchStore;
};

export const initialSearchState: ElevioSearchState = {
  searchStore: {},
  searchInputValue: '',
};

export const searchReducer = createReducer(initialSearchState, (builder) =>
  builder
    .addCase(
      searchActions.setInitialConversationSearchState,
      (state, action) => {
        state.searchStore[action.payload.conversationId] = {
          searchTerm: '',
        };
      },
    )
    .addCase(searchActions.setSearchTerm, (state, action) => {
      const { conversationId } = action.payload;
      if (state.searchStore[conversationId]) {
        state.searchStore[conversationId].searchTerm = action.payload.term;
      } else {
        state.searchStore[conversationId] = {
          searchTerm: action.payload.term,
        };
      }
    })
    .addCase(searchActions.setSearchInputValue, (state, action) => {
      state.searchInputValue = action.payload.value;
    })
    .addCase(searchActions.initialiseInputValue, (state, action) => {
      state.searchInputValue = action.payload.value;
    }),
);
